import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { useMap } from '../../contexts/MapContext';

// Custom icon for user location
const userIcon = new L.Icon({
  iconUrl: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjMzM5OUNDIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI4IiBmaWxsPSIjMzM5OUNDIiBmaWxsLW9wYWNpdHk9IjAuMyIgc3Ryb2tlPSIjMzM5OUNDIiBzdHJva2Utd2lkdGg9IjIiLz48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI0IiBmaWxsPSIjMzM5OUNDIi8+PC9zdmc+',
  iconSize: [24, 24],
  iconAnchor: [12, 12],
  popupAnchor: [0, -12],
});

const LocationMarker: React.FC = () => {
  const { userLocation } = useMap();

  if (!userLocation) return null;

  const position = Array.isArray(userLocation) 
    ? userLocation 
    : [userLocation.lat, userLocation.lng];

  return (
    <Marker position={position as [number, number]} icon={userIcon}>
      <Popup>
        <div style={{ textAlign: 'center' }}>
          <strong>Your Location</strong>
          <br />
          <small>Drag the Gaza overlay to compare</small>
        </div>
      </Popup>
    </Marker>
  );
};

export default LocationMarker;